module.exports = __webpack_public_path__ + "img/neotag-banner1.52bf4d2f.png";